import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=032a570e&scoped=true"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"
import "./BaseField.vue?vue&type=style&index=0&id=032a570e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a570e",
  null
  
)

export default component.exports